import React from "react";
import { Helmet } from "react-helmet-async";
import { Grid, Container } from "@mui/material";
import AppWidgetSummary from "../sections/app/AppWidgetSummary";
import { httpClient } from "../Service/Service";
import Loading from "common/Loading";
import { allSVReadyList } from "Service/agent.service";
import DataGrid from "components/table/DataGrid";
import FullConsumerTable from "../components/FullConsumerTable";



const svReadyColumns = [
  { field: "name", title: "Name" },
  { field: "familyAadhaar", title: "Family Aadhaar" },
  { field: "mainAadhaar", title: "Main Aadhaar" },
  { field: "installtatus", title: "Install Status" },
  { field: "isSingleWomen", title: "Single Women" },
  { field: "isFreeDelivery", title: "Free Delivery" },
  { field: "regNo", title: "Registration No" },
  { field: "mainAgent", title: "Main Agent" },
  { field: "subAgent", title: "Sub Agent" },
  { field: "mobile", title: "Mobile" },
  { field: "consumerNo", title: "Consumer No" },
  { field: "registeredAgencyName", title: "Registered Agency" },
  { field: "registrationStatus", title: "Registration Status" },
  { field: "updatedBy", title: "Updated By" },
  { field: "newRegisteredAgency", title: "New Registered Agency" },
  { field: "remarks", title: "Remarks" },
  { field: "createdAt", title: "Created At" }
];

export default function DashboardAppPage() {

  const [loading, setLoading] = React.useState(false);
  const [svReadyData, setSvReadyData] = React.useState<any[]>([]);
  const [showSvReadyTable, setShowSvReadyTable] = React.useState(false);
  const [showConsumer, setShowConsumer] = React.useState(false);
  const [dashboard, setDashboard] = React.useState({
    CustomerCount: 0,
    agentCount: 0,
    oldCustomerCount: 0,
    pendingFinger: 0,
    svReadyList: 0,
    userCount: 0,
  });

  const effectRan = React.useRef(false);

  const handleSvReadyClick = async () => {
    try {
      setLoading(true);
      const data = await allSVReadyList();
      if (Array.isArray(data)) {
        setSvReadyData(data);
      }
      setShowSvReadyTable(!showSvReadyTable);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowConsumer = () => {
    setShowConsumer(!showConsumer);
  };

  React.useEffect(() => {
    if (effectRan.current === false) {
      const fetchCount = async () => {
        try {
          setLoading(true);

          const result: any = await httpClient("customer/count", "POST", {
            project: "GET_COUNT",
          });
          if (result.data) {
            setDashboard(result.data);
          }
        } catch (error) {
          console.error(error);
        } finally {
          setLoading(false);
        }
      };
      fetchCount();
    }

    return () => {
      effectRan.current = true;
    };
  }, []);




  return (
    <>
      <Helmet>
        <title> Dashboard | Jaman HP Gas </title>
      </Helmet>
      <Container maxWidth="xl">
        {loading ? <Loading /> :
          <div>
            <Grid container spacing={3}>


              <Grid item xs={12} sm={6} md={4}>
                <AppWidgetSummary
                  title="New Custoners"
                  total={dashboard.CustomerCount}
                  success icon={"mdi:clipboard-user"}
                  onClick={handleShowConsumer}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>

                <AppWidgetSummary
                  title="Old Customers"
                  total={dashboard.oldCustomerCount}
                  color="warning"
                  icon={"hugeicons:ai-user"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>

                <AppWidgetSummary
                  title="Pending fingerprint"
                  total={dashboard.pendingFinger}
                  color="error"
                  icon={"mdi:fingerprint-off"}
                />
              </Grid>


            </Grid>
            <Grid container spacing={3} mt={3}>
              <Grid item xs={12} sm={6} md={4}>

                <AppWidgetSummary
                  title="All Agents"
                  total={dashboard.agentCount}
                  color="info"
                  icon={"mdi:face-agent"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>

                <AppWidgetSummary
                  title="Total Member"
                  total={dashboard.userCount}
                  style={{ color: "#e91e63", backgroundColor: "#f8bbd0" }}
                  icon={"mdi:user-tie"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>

                <AppWidgetSummary
                  style={{ color: "#009688", backgroundColor: "#b2dfdb", cursor: "pointer" }}
                  title="SV Ready List"
                  total={dashboard.svReadyList}
                  icon={"mdi:user-check"}
                  onClick={handleSvReadyClick}
                />
              </Grid>

            </Grid>
            <Grid container spacing={3} mt={3}>
              <Grid item xs={12} sm={6} md={4}>
                <AppWidgetSummary
                  title="Total Connection Delivery Report"
                  total={dashboard.agentCount}
                  style={{
                    color: "#f7dbbfff",
                    backgroundColor: "#e7a24dff",
                  }}
                  icon={"fluent-emoji-high-contrast:delivery-truck"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <AppWidgetSummary
                  title="Complete Fingerprint but SwasthyaSathi Pending"
                  total={dashboard.userCount}
                  style={{
                    color: "#821982ff",
                    backgroundColor: "hsla(271, 78%, 79%, 1.00)",
                  }}
                  icon={"streamline-pixel:interface-essential-waiting-hourglass-loading"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <AppWidgetSummary
                  style={{
                    color: "#08660d",
                    backgroundColor: "#c8facd",
                    cursor: "pointer",
                  }}
                  title="TOTAL INSTALLATION COMPLETE"
                  total={dashboard.svReadyList}
                  icon={"hugeicons:note-done"}
                  onClick={handleSvReadyClick}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} mt={4}>
              <Grid item xs={12} sm={12} md={12}>
                {showSvReadyTable && (
                  <DataGrid title="SV Ready List" rows={svReadyData} columns={svReadyColumns} />
                )}
                {showConsumer && (<FullConsumerTable />)}
              </Grid>
            </Grid>
          </div>}

      </Container >
    </>
  );
}
